// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"style_breadcrumbs__1Yw6Z","activeMenu":"style_activeMenu__3c6bK","arrow":"style_arrow__1NmmK"};